import React from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import './TalkExpert.scss';
import './TalkExpertResponsive.scss';

const TalkExpert = () => {
	const industryContent = useSelector((state) => state.content?.industry);
	const industryData = industryContent?.content ? JSON.parse(industryContent?.content) : '';

	return (
		<>
			<section className="talkExpert text-center">
				<div className="talkExpertInner">
					<h3
						dangerouslySetInnerHTML={{
							__html: industryData?.section3?.heading ?? `Talk To An Expert`,
						}}
					></h3>
					<p
						dangerouslySetInnerHTML={{
							__html:
								industryData?.section3?.description ??
								`Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Quis ipsum suspendisse ultrices
							gravida. Risus commodo viverra maecenas accumsan lacus vel facilisis.`,
						}}
					></p>
					<Link className="freeQuoteBtn mt-4" to={'/contact'}>
						Request a free Quote
					</Link>
				</div>
			</section>
		</>
	);
};

export default TalkExpert;
